module.exports = ":host::ng-deep [data-render-style='marquee'], :host::ng-deep [data-render-style='spotlight'] {\n  margin-top: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/row-container/row-container.styles.scss
// module id = 719
// module chunks = 2